import { render } from "./App.vue?vue&type=template&id=ddf4f344"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ddf4f344&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/AS3/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__